import React from 'react';
import { StyledLoading } from './style';
import { LayoutProps } from 'styled-system';

type SpinnerType = LayoutProps & {
  type?: 'primaryGreen' | 'green' | 'blue';
};

const LoadingSpinner: React.FC<SpinnerType> = ({ type, ...rest }) => {
  return <StyledLoading type={type} {...rest}></StyledLoading>;
};

export default LoadingSpinner;
